import { createContext, type ReactNode, useContext } from "react";
import type { MarginProps } from "../../utils/layout";
import { Card } from "../Card/Card";
const ListGroupContext = createContext(false);
export const useInListGroup = () => useContext(ListGroupContext);

/** Inset so a row's press fill clears the card's corners. */
export const ListGroup = ({
  children,
  ...margins
}: MarginProps & {
  children: ReactNode;
}) => <Card variant="elevated" size="large" padding="$sp1" {...margins} data-sentry-element="Card" data-sentry-component="ListGroup" data-sentry-source-file="ListGroup.tsx">
    <ListGroupContext.Provider value={true} data-sentry-element="ListGroupContext.Provider" data-sentry-source-file="ListGroup.tsx">
      {children}
    </ListGroupContext.Provider>
  </Card>;